import { useEffect, useState } from 'react';

/**
 * Keeps a component mounted for `ms` after it closes, so a CSS exit transition
 * has something to animate.
 *
 * The alternative — leaving an overlay permanently mounted and parked off-screen
 * with translateX(100%) — silently adds its width to document.scrollWidth and
 * gives every page a horizontal scrollbar.
 */
export function useDelayedUnmount(open, ms = 400) {
  const [mounted, setMounted] = useState(open);

  useEffect(() => {
    if (open) {
      setMounted(true);
      return undefined;
    }
    const t = setTimeout(() => setMounted(false), ms);
    return () => clearTimeout(t);
  }, [open, ms]);

  return mounted;
}
